(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product"]) return;
  try {
    
document.querySelectorAll('#ss-variant').forEach(function(select){var section=select.closest('section');var fallback=section.querySelector('[data-ss-select]');if(fallback)fallback.hidden=true;select.addEventListener('change',function(){var option=select.selectedOptions[0];section.querySelector('input[name=id]').value=option.value;section.querySelector('[data-ss-price]').textContent=option.dataset.price;section.querySelector('[data-ss-sku]').textContent='SKU: '+option.dataset.sku;var button=section.querySelector('.ss-add');button.disabled=option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?select.dataset.addLabel:select.dataset.soldOut;var url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);});});

  } catch(e) { console.error(e); }
})();
})();
